import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react'

import cn from 'clsx'

import s from './styles.module.scss'
type CardType = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  headerRightElement?: ReactNode
  title?: string | ReactNode
  contentClassName?: string
}

export const Card = ({ children, headerRightElement, title, contentClassName, ...props }: CardType) => {
  return (
    <div {...props} className={cn(s.container, props.className)}>
      <div className={s.header}>
        <div className={s.title}>{title}</div>
        {headerRightElement}
      </div>
      <div className={cn(s.content, contentClassName)}>{children}</div>
    </div>
  )
}
